import type { QuerySettings } from '@customTypes/index';
import { useQuery } from '@tanstack/react-query';

import { getCategorisedActivityesList } from './request';

export const useGetCategorisedActivityesListQuery = (
  settings?: QuerySettings<typeof getCategorisedActivityesList>
) =>
  useQuery({
    queryKey: ['GetCategorisedActivityesList'],
    queryFn: () =>
      getCategorisedActivityesList({
        config: settings?.config
      }),
    ...settings?.options
  });
